// extracted by mini-css-extract-plugin
export default {"card":"card_card__cL7IG","currentcard":"card_currentcard__OzokW","content":"card_content__ZqICm","name":"card_name__28ouQ","img":"card_img__D6aaY","names":"card_names__1WL18"};